module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABXElEQVQ4T62Uu04CQRiFzxmNnfEJuKiFPgJCAgYlVHbGZU0sLCx8IhMtTLQAjJ2NCdHINbwBFF5A4wOglSjzm1kFiS4Xs0x55p9vzp6d/ydcViBvxzktlhbECfGbEgEfFXH93sHZczRz9fsY+4VgxV4WLQeArLpd8KPxhor7jXC63tV6oGDBjonSFwBmh0N6u6/UaqMRTeeN4oAcJ6KrEMyNCfkqI1qkChlnNB8fKKcqgITcII1IxpGD5dSAO1htRjJhLhS31jtkbpCT0SBgSiRh3BxCZM8LCOQR/aXULSGLXkAC3jFQst4AzHgBAWgb0MuwXz5ORg7IX7LrhF7y4kiAexP2CUR2/vV+/vQHT+krbCeV6lx6ASkiObkHOapFhoZNtPCBlWYsW5ts03bz+R4jx4P6rm+MVKm46zpGekUCzleshAY3RWSNgE+ANoAnkkUFOX8IZ3Mw6fatT1W8pVs+48lFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newimg/tipsS.png
// module id = 1mXy
// module chunks = 35